import { inject } from '@angular/core';
import { catchError, map, of, switchMap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ActivatedRouteSnapshot, CanActivateFn, GuardResult, MaybeAsync, RouterStateSnapshot } from '@angular/router';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : MaybeAsync<GuardResult> => {
  const authService = inject(AuthService);

  if (!authService.authToken || authService.isTokenExpired()) {
    authService.redirectExpiredSessionToLogin(state.url);
    return false;
  }

  // Try to renew access token to extend session
  return authService.refreshAccessToken().pipe(
    switchMap(() => authService.isLoggedIn),
    map((isLoggedIn) => {
      if (!isLoggedIn) {
        authService.redirectExpiredSessionToLogin(state.url);
      }

      return isLoggedIn;
    }),
    catchError(() => {
      authService.redirectExpiredSessionToLogin(state.url);
      return of(false);
    })
  );
};
